import { render, staticRenderFns } from "./HomeAdvantage.vue?vue&type=template&id=265a7f91&scoped=true"
import script from "./HomeAdvantage.vue?vue&type=script&lang=js"
export * from "./HomeAdvantage.vue?vue&type=script&lang=js"
import style0 from "./HomeAdvantage.vue?vue&type=style&index=0&id=265a7f91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265a7f91",
  null
  
)

export default component.exports